import React, { useState, useEffect, useRef } from 'react'
import { KnovaText } from '../BasicUIComponents/KnovaText'
import { KnovaInput } from '../BasicUIComponents/KnovaInput'
import KnovaSelect from '../BasicUIComponents/KnovaSelect'

function SCEPMultiInput(props) {
  const {
    isPractice,
    Completed,
    isActive,
    componentData,
    themeColors,
    themeFont,
    isSideMenu,
    layoutType,
    isOutsideClick,
    isFollowTheFlow,
    priorityActive,
    isAudioPlaying,
    isMinimize,
    isReplaying,
    isExtraPractice,
    isNextMove
  } = props
  const {
    defaultValue,
    onValueChange,
    onPriorityChange,
    handleSucAndFailFeedback,
    getCurrentSelectedOption
  } = props

  const {
    ControlID,
    Options,
    Score,
    LayoutType,
    Priority,
    Topic,
    Description,
    OperationType
  } = componentData

  const [dropdownData, setDropdownData] = useState({
    SelectedOptions: [],
    Value: 0
  })
  const [currentSelectedInput, setcurrentSelectedInput] = useState(-1)
  const [failureCount, setFailureCount] = useState(0)
  const [onBlurCall, setOnBlurCall] = useState(true)
  const [filedsInputData, setFiledsInputData] = useState([])

  useEffect(() => {
    if (onBlurCall) {
      if (defaultValue) {
        if (defaultValue.CtlValue) {
          setDropdownData({
            SelectedOptions: defaultValue.CtlValue,
            Value: defaultValue.CtlScore
          })
        }
        setOnBlurCall(false)
      }
    }
  }, [defaultValue])

  //selected drop down
  useEffect(() => {
    let selectedOptionsData = []
    if (OperationType === 'pemdas') {
      Options.map((item, index) => {
        selectedOptionsData[index] = {
          Answer: '',
          Value: 0
        }
      })
    } else {
      Options.map((item, index) => {
        let fieldArrayCopy = []
        item.Fields.map((fieldInput, fieldInputIndex) => {
          fieldArrayCopy[fieldInputIndex] = {
            Answer: '',
            isCorrect: false
          }
        })
        selectedOptionsData[index] = fieldArrayCopy
      })
    }
    console.log('selectedOptionsData', selectedOptionsData)
    let dropdownDataCopy = { SelectedOptions: selectedOptionsData, Value: 0 }
    setDropdownData(dropdownDataCopy)
  }, [componentData])

  //Failure message Sequence
  function handleFailureFeedback(failureData) {
    let feedbackAudioData = failureData
    let failureFeedback = {}
    if (feedbackAudioData.length > 0) {
      if (failureCount === 0) {
        if (
          feedbackAudioData[1] &&
          feedbackAudioData[1].failureAudioLink !== ''
        ) {
          setFailureCount(1)
        } else {
          setFailureCount(0)
        }
        failureFeedback = feedbackAudioData[0]
      } else if (failureCount === 1) {
        if (
          feedbackAudioData[2] &&
          feedbackAudioData[2].failureAudioLink !== ''
        ) {
          setFailureCount(2)
        } else {
          setFailureCount(0)
        }
        failureFeedback = feedbackAudioData[1]
      } else if (failureCount === 2) {
        setFailureCount(0)
        failureFeedback = feedbackAudioData[2]
      }
    } else {
      failureFeedback = {
        failureAudioLink: '',
        failureFeedback: []
      }
    }
    handleSucAndFailFeedback(false, failureFeedback)
  }

  //Input validation function
  function handleInputData(selectedOption, selectedIndex) {
    if (selectedOption && selectedOption !== '' && selectedOption !== null) {
      let dropdownDataCopy = { ...dropdownData }
      let dropdownScore = 0
      dropdownDataCopy.SelectedOptions[selectedIndex].Answer = selectedOption
      const isCaseSensitive = Options[selectedIndex].CaseSensitive
      const correctAnswerText = Options[selectedIndex].CorrectAnswer
      if (!isCaseSensitive) {
        //Handle feedback for selected answer
        if (isPractice) {
          if (isFollowTheFlow) {
            if (selectedOption === correctAnswerText) {
              if (Options[selectedIndex].FeedbackAudioData.successData) {
                handleSucAndFailFeedback(
                  true,
                  Options[selectedIndex].FeedbackAudioData.successData
                )
                setFailureCount(0)
              } else {
                onPriorityChange(Priority)
              }
            } else {
              let selectedOption = Options[selectedIndex]
              let feedbackAudioData =
                selectedOption.FeedbackAudioData.failureData
              handleFailureFeedback(feedbackAudioData)
            }
          }
        } else {
          onPriorityChange(Priority)
        }
        //Calculate score
        if (selectedOption === correctAnswerText) {
          dropdownDataCopy.SelectedOptions[selectedIndex].Value =
            Options[selectedIndex].Score
        } else {
          dropdownDataCopy.SelectedOptions[selectedIndex].Value = 0
        }
      } else {
        //Handle feedback for selected answer
        if (isPractice) {
          if (isFollowTheFlow) {
            if (
              selectedOption.toLowerCase() === correctAnswerText.toLowerCase()
            ) {
              if (Options[selectedIndex].FeedbackAudioData.successData) {
                handleSucAndFailFeedback(
                  true,
                  Options[selectedIndex].FeedbackAudioData.successData
                )
                setFailureCount(0)
              } else {
                onPriorityChange(Priority)
              }
            } else {
              let selectedOption = Options[selectedIndex]
              let feedbackAudioData =
                selectedOption.FeedbackAudioData.failureData
              handleFailureFeedback(feedbackAudioData)
            }
          }
        } else {
          onPriorityChange(Priority)
        }
        //Calculate score
        if (selectedOption.toLowerCase() === correctAnswerText.toLowerCase()) {
          dropdownDataCopy.SelectedOptions[selectedIndex].Value =
            Options[selectedIndex].Score
        } else {
          dropdownDataCopy.SelectedOptions[selectedIndex].Value = 0
        }
        dropdownDataCopy.SelectedOptions.map((selctData, selctIndex) => {
          dropdownScore += parseFloat(selctData.Value)
        })
      }

      //Student score for this component
      dropdownDataCopy.Value = dropdownScore
      setDropdownData(dropdownDataCopy)
      onValueChange(
        ControlID,
        dropdownDataCopy.SelectedOptions,
        dropdownDataCopy.Value,
        Score,
        [],
        false
      )
      setOnBlurCall(true)
    }
  }

  //Multi dropdown validation
  function handleMultiInputComponent(
    selectedOption,
    selectedIndex,
    selectedFieldIndex
  ) {
    // console.log('selectedIndex', selectedIndex)
    // console.log('selectedFieldIndex', selectedFieldIndex)
    if (selectedOption && selectedOption !== '' && selectedOption !== null) {
      let dropdownDataCopy = { ...dropdownData }
      dropdownDataCopy.SelectedOptions[selectedIndex][
        selectedFieldIndex
      ].Answer = selectedOption
      let feedbackData =
        Options[selectedIndex].Fields[selectedFieldIndex].FeedbackAudioData
      if (
        Options[selectedIndex].Fields[selectedFieldIndex].CorrectAnswer ===
        selectedOption
      ) {
        dropdownDataCopy.SelectedOptions[selectedIndex][
          selectedFieldIndex
        ].isCorrect = true
        let feedbackAudioData = feedbackData.successData
        handleSucAndFailFeedback(true, feedbackAudioData)
        setFailureCount(0)
      } else {
        dropdownDataCopy.SelectedOptions[selectedIndex][
          selectedFieldIndex
        ].isCorrect = false
        let feedbackAudioData = feedbackData.failureData
        handleFailureFeedback(feedbackAudioData)
        handleSucAndFailFeedback(false, feedbackAudioData)
        setFailureCount(0)
      }
      setDropdownData(dropdownDataCopy)
    }
  }

  useEffect(() => {
    if (isNextMove) {
      const presentIndex = Options.findIndex(
        (item) => item.Priority === priorityActive
      )
      if (presentIndex > -1) {
        let dropDownCopy = dropdownData.SelectedOptions[presentIndex]
        if (dropDownCopy.length > 0) {
          const canGoToNextStep = dropDownCopy.every(
            (item) => item.isCorrect === true
          )
          if (canGoToNextStep) {
            onPriorityChange()
            // Move to next step
            console.log('Proceed to next step')
          } else {
            console.log('Wait until a correct answer is selected')
          }
        }
      }
    }

    // if (condition) {

    // }
  }, [dropdownData, isNextMove])

  if (dropdownData.SelectedOptions.length > 0) {
    return (
      <div
        className='sc-dropdown-main'
        style={{
          justifyContent: 'start',
          gap: isMinimize ? '0px' : '10px',
          overflow: 'auto'
        }}
      >
        {Options.map((optionData, optionIndex) => {
          return (
            <div className='glass-box'>
              <div
                style={{
                  filter: isFollowTheFlow
                    ? optionData.Priority <= priorityActive
                      ? 'unset'
                      : 'blur(3px)'
                    : 'unset'
                }}
              >
                <KnovaText
                  contWidth={'100%'}
                  contMargin={'0 24px 0 0'}
                  contPadding={isSideMenu ? '0px' : '0px 12px'}
                  text={optionData.Topic + ' : ' + optionData.Description}
                  textColor={themeColors.onBackground}
                  textFontSize={
                    isSideMenu ? '5px' : isMinimize ? '16px' : '20px'
                  }
                  textFontFamily={themeFont.bodyFont}
                  textFontWeight='400'
                  letterSpacing='0.32px'
                />
              </div>
              {OperationType === 'pemdas' ? (
                <div
                  key={'dropdownList' + optionIndex}
                  className='sc-dropdown-contn'
                  style={{
                    flexDirection:
                      LayoutType === 'inline' || isExtraPractice
                        ? 'row'
                        : 'column',
                    filter: isFollowTheFlow
                      ? optionData.Priority <= priorityActive
                        ? 'unset'
                        : 'blur(3px)'
                      : 'unset'
                  }}
                >
                  {optionData.InputType !== 'label' && (
                    <KnovaText
                      contWidth={
                        LayoutType === 'inline' || isExtraPractice
                          ? 'fit-content'
                          : '100%'
                      }
                      contMargin={
                        LayoutType === 'inline' || isExtraPractice
                          ? '0 24px 0 0'
                          : 'unset'
                      }
                      contPadding={isSideMenu ? '0px' : '0px 12px'}
                      text={
                        isSideMenu
                          ? 'Question ' + (optionIndex + 1)
                          : optionData.QuestionText
                      }
                      textColor={themeColors.onBackground}
                      textFontSize={
                        isSideMenu ? '5px' : isMinimize ? '16px' : '20px'
                      }
                      textFontFamily={themeFont.bodyFont}
                      textFontWeight='400'
                      letterSpacing='0.32px'
                    />
                  )}

                  <div
                    className='mcq-option-style'
                    style={{
                      display: 'flex',
                      width: isExtraPractice
                        ? '20%'
                        : optionData.InputType === 'input'
                        ? LayoutType === 'inline'
                          ? 'fit-content'
                          : '100%'
                        : LayoutType === 'inline'
                        ? '352px'
                        : '100%',
                      minWidth:
                        LayoutType === 'inline' || isExtraPractice
                          ? '20%'
                          : 'unset',
                      pointerEvents:
                        Completed === 1 ||
                        !isActive ||
                        isAudioPlaying ||
                        isReplaying
                          ? 'none'
                          : isFollowTheFlow
                          ? isPractice
                            ? optionData.Priority === priorityActive
                              ? 'auto'
                              : 'none'
                            : optionData.Priority > priorityActive
                            ? 'none'
                            : 'auto'
                          : 'auto'
                    }}
                    onClick={() => {
                      if (optionData.InputType === 'input' || isExtraPractice) {
                        setcurrentSelectedInput(optionIndex)
                      }
                    }}
                  >
                    <KnovaInput
                      contBgColor={themeColors.surfaceVarient}
                      contMargin={isSideMenu ? '1px 0px' : '9px 0px'}
                      contPadding={isSideMenu ? '1px' : '16px 24px'}
                      contBorderColor={
                        isPractice || Completed === 1 || !isActive
                          ? dropdownData.SelectedOptions[optionIndex].Answer ===
                            ''
                            ? themeColors.outline
                            : dropdownData.SelectedOptions[optionIndex]
                                .Answer === Options[optionIndex].CorrectAnswer
                            ? themeColors.successContainer
                            : themeColors.errorContainer
                          : themeColors.outline
                      }
                      contBorderWidth={isSideMenu ? '1px' : '2px'}
                      contBorderRadius={isSideMenu ? '3px' : '12px'}
                      text={dropdownData.SelectedOptions[optionIndex].Answer}
                      textColor={themeColors.onSurfaceVarient}
                      textFontSize={isSideMenu ? '5px' : '16px'}
                      textFontFamily={themeFont.bodyFont}
                      textFontWeight='400'
                      // textOpacity={
                      //   dropdownData.SelectedOptions[optionIndex].Answer === ''
                      //     ? 0.3
                      //     : 1
                      // }
                      onTextChage={(textValue) => {
                        handleInputData(textValue, currentSelectedInput)
                      }}
                    />
                  </div>
                  {dropdownData.SelectedOptions[optionIndex].Answer ===
                    Options[optionIndex].CorrectAnswer &&
                    optionData.TextAfter !== '' &&
                    optionIndex < Options.length - 1 && (
                      <KnovaText
                        contWidth='fit-content'
                        contMargin='0 24px 0 0'
                        contPadding='0px 12px'
                        text={'= ' + optionData.TextAfter}
                        textColor={themeColors.onBackground}
                        textFontSize='22px'
                        textFontFamily='Kalam'
                        textFontWeight='400'
                        letterSpacing='0.32px'
                      />
                    )}
                </div>
              ) : (
                <div
                  key={'dropdownListSimple' + optionIndex}
                  className='sc-dropdown-contn'
                  style={{
                    flexDirection:
                      LayoutType === 'inline' || isExtraPractice
                        ? 'row'
                        : 'column',
                    filter: isFollowTheFlow
                      ? optionData.Priority <= priorityActive
                        ? 'unset'
                        : 'blur(3px)'
                      : 'unset',
                    paddingLeft: '2%'
                  }}
                >
                  {optionData.Fields &&
                    optionData.Fields.length > 0 &&
                    optionData.Fields.map((filedData, fieldIndex) => {
                      return (
                        <div
                          key={'field' + optionIndex + '' + fieldIndex}
                          className='sc-ep-dropdown-contn'
                          style={{
                            flexDirection:
                              LayoutType === 'inline' || isExtraPractice
                                ? 'row'
                                : 'column',
                            filter: isFollowTheFlow
                              ? optionData.Priority <= priorityActive
                                ? 'unset'
                                : 'blur(3px)'
                              : 'unset'
                          }}
                        >
                          <KnovaInput
                            contWidth='100px'
                            contBgColor={themeColors.surfaceVarient}
                            contMargin={'9px 0px'}
                            contPadding={'10px 5px'}
                            contBorderColor={
                              dropdownData.SelectedOptions[optionIndex][
                                fieldIndex
                              ].Answer === ''
                                ? themeColors.outline
                                : dropdownData.SelectedOptions[optionIndex][
                                    fieldIndex
                                  ].Answer ===
                                  Options[optionIndex].Fields[fieldIndex]
                                    .CorrectAnswer
                                ? themeColors.successContainer
                                : themeColors.errorContainer
                            }
                            // contBorderColor={
                            //   isPractice || Completed === 1 || !isActive
                            //     ? dropdownData.SelectedOptions[optionIndex]
                            //         .Answer === ''
                            //       ? themeColors.outline
                            //       : dropdownData.SelectedOptions[optionIndex]
                            //           .Answer ===
                            //         Options[optionIndex].CorrectAnswer
                            //       ? themeColors.successContainer
                            //       : themeColors.errorContainer
                            //     : themeColors.outline
                            // }
                            contBorderWidth={'2px'}
                            contBorderRadius={'12px'}
                            text={
                              dropdownData.SelectedOptions[optionIndex].Answer
                            }
                            textColor={themeColors.onSurfaceVarient}
                            textFontSize={'16px'}
                            textFontFamily={themeFont.bodyFont}
                            textFontWeight='400'
                            onTextChage={(textValue) => {
                              handleMultiInputComponent(
                                textValue,
                                optionIndex,
                                fieldIndex
                              )
                            }}
                          />
                          <KnovaText
                            contWidth={''}
                            contMargin={'0px'}
                            contPadding={'0px 12px'}
                            text={
                              fieldIndex < optionData.Fields.length - 1
                                ? filedData.TextAfter === ''
                                  ? filedData.label + ' and'
                                  : filedData.label + ' ' + filedData.TextAfter
                                : filedData.label
                            }
                            textColor={themeColors.onBackground}
                            textFontSize={'20px'}
                            textFontFamily={themeFont.bodyFont}
                            textFontWeight='400'
                            letterSpacing='0.32px'
                          />
                        </div>
                      )
                    })}
                </div>
              )}
            </div>
          )
        })}
      </div>
    )
  } else {
    return null
  }
}

export default SCEPMultiInput
